export default __webpack_public_path__ + "locales/pt-BR/Translations.json?hash=ea69bc49f901b69674c1c0f1a33b7bbc";